<template>
  <div class="component">
    <v-tabs
      v-model="activeTab"
      background-color="transparent"
      class="tabs"
    >
      <v-tab class="tab-my-team">
        {{ $t('mega_league.tabs.my_team') }}
      </v-tab>
      <v-tab>
        {{ $t('mega_league.tabs.leaderboard') }}
      </v-tab>
      <status
        v-if="gameWeek"
        :game-week="gameWeek"
        :is-loading="isLoading"
        :users-count="userMegaLeague?.usersCount"
        :status-confirmed="statusConfirmed"
      />
    </v-tabs>

    <v-tabs-window v-model="activeTab">
      <v-tabs-window-item>
        <user-score
          v-if="userMegaLeague"
          :user-mega-league="userMegaLeague"
        />
        <lineup
          v-if="lineup"
          :lineup="lineup"
          :players="players"
          :game-week="gameWeek"
          show-average-score
        />
      </v-tabs-window-item>
      <v-tabs-window-item>
        <leaderboard :game-week="gameWeek" />
      </v-tabs-window-item>
    </v-tabs-window>
  </div>
</template>

<script>
import Leaderboard from "@/components/MegaLeague/Leaderboard.vue";
import Status from "@/components/Lineup/Status.vue";
import Lineup from "@/components/Lineup/Lineup.vue";
import MegaLeagueService from "@/services/megaLeague.service";
import GameWeek from "@/models/GameWeek/gameWeek";
import UserScore from "@/components/UserScore.vue";

export default {
  name: "MegaLeagueRead",
  components: {
    Leaderboard,
    Status,
    Lineup,
    UserScore,
  },
  props: {
    gameWeek: {
      type: GameWeek,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 0,
      userMegaLeague: null,
      players: [],
      isLoading: false,
      statusConfirmed: false,
    };
  },
  computed: {
    lineup() {
      return this.userMegaLeague?.lineup;
    },
  },
  watch: {
    $route() {
      this.getUserMegaLeague();
    },
  },
  mounted() {
    this.getUserMegaLeague();
  },
  methods: {
    getUserMegaLeague() {
      this.isLoading = true;
      MegaLeagueService.getUserMegaLeague(this.gameWeek.number)
        .then((response) => {
          this.userMegaLeague = response;
          this.statusConfirmed = this.userMegaLeague.lineup.isSet();
          this.lineupUpdated();
        })
        .catch(() => {
          this.userMegaLeague = null;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    lineupUpdated() {
      this.updatePlayers();
    },
    updatePlayers() {
      this.players = this.userMegaLeague?.lineup.getCards().map((card) => card.player);
    },
  },
};
</script>

<style scoped lang="scss">
.tabs {
  border-top-left-radius: 15px;
  overflow: hidden;
}

.status {
  margin-right: 10px;
}
</style>
